import EventEmitter from "eventemitter3";

export const auth = new EventEmitter<{
  change: [{
    member_id: number;
    site_id: number;
    role: string;
  }]
}>();
